export function SiteTemplate({
    name = 'Org Docs',
    ...props
}: React.ComponentPropsWithoutRef<'svg'> & { name?: string }) {
    return (
        <div className="flex translate-x-3 translate-y-[54px] transform">
            <svg
                width={1079}
                height={579}
                viewBox="0 0 1079 579"
                fill="none"
                className="relative rounded-lg shadow-elevated dark:shadow-subtle"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <rect width={1079} height={579} fill="var(--sp-color-bg-base)" />
                <title>Visual asset of site template</title>
                <path
                    d="M1031.3 0H7.70343C3.44894 0 0 3.10741 0 6.9406V495.385C0 499.218 3.44894 502.326 7.70343 502.326H1031.3C1035.55 502.326 1039 499.218 1039 495.385V6.9406C1039 3.10741 1035.55 0 1031.3 0Z"
                    fill="var(--sp-color-bg-base)"
                />
                <rect
                    x="273.381"
                    y="466.102"
                    width="150.347"
                    height="113.672"
                    rx="7.24757"
                    fill="var(--sp-color-bg-side)"
                />
                <rect
                    x="273.381"
                    y="466.102"
                    width="150.347"
                    height="113.672"
                    rx="7.24757"
                    stroke="var(--sp-color-bg-side)"
                    stroke-width="0.762902"
                />
                <circle cx="295.887" cy="488.608" r="7.62902" fill="#FE551B" />
                <rect
                    x="444.327"
                    y="466.102"
                    width="150.347"
                    height="113.672"
                    rx="7.24757"
                    fill="var(--sp-color-bg-side)"
                />
                <rect
                    x="444.327"
                    y="466.102"
                    width="150.347"
                    height="113.672"
                    rx="7.24757"
                    stroke="var(--sp-color-bg-side)"
                    stroke-width="0.762902"
                />
                <circle cx="466.832" cy="488.608" r="7.62902" fill="#FE551B" />
                <rect
                    x="615.272"
                    y="466.102"
                    width="150.347"
                    height="113.672"
                    rx="7.24757"
                    fill="var(--sp-color-bg-side)"
                />
                <rect
                    x="615.272"
                    y="466.102"
                    width="150.347"
                    height="113.672"
                    rx="7.24757"
                    stroke="var(--sp-color-bg-side)"
                    stroke-width="0.762902"
                />
                <circle cx="637.777" cy="488.608" r="7.62902" fill="#FE551B" />
                <path
                    d="M423.689 435.527H277.324C275.196 435.527 273.472 437.08 273.472 438.997C273.472 440.914 275.196 442.467 277.324 442.467H423.689C425.816 442.467 427.54 440.914 427.54 438.997C427.54 437.08 425.816 435.527 423.689 435.527Z"
                    fill="var(--sp-color-bg-side)"
                />
                <path
                    d="M756.862 418.176H277.324C275.196 418.176 273.472 419.729 273.472 421.646C273.472 423.562 275.196 425.116 277.324 425.116H756.862C758.989 425.116 760.714 423.562 760.714 421.646C760.714 419.729 758.989 418.176 756.862 418.176Z"
                    fill="var(--sp-color-bg-side)"
                />
                <path
                    d="M645.162 383.473H277.324C275.196 383.473 273.472 385.026 273.472 386.943C273.472 388.86 275.196 390.413 277.324 390.413H645.162C647.29 390.413 649.014 388.86 649.014 386.943C649.014 385.026 647.29 383.473 645.162 383.473Z"
                    fill="var(--sp-color-bg-side)"
                />
                <path
                    d="M756.862 366.121H277.324C275.196 366.121 273.472 367.675 273.472 369.592C273.472 371.508 275.196 373.062 277.324 373.062H756.862C758.989 373.062 760.714 371.508 760.714 369.592C760.714 367.675 758.989 366.121 756.862 366.121Z"
                    fill="var(--sp-color-bg-side)"
                />
                <path
                    d="M548.869 331.418H277.324C275.196 331.418 273.472 332.972 273.472 334.889C273.472 336.805 275.196 338.359 277.324 338.359H548.869C550.997 338.359 552.721 336.805 552.721 334.889C552.721 332.972 550.997 331.418 548.869 331.418Z"
                    fill="var(--sp-color-bg-side)"
                />
                <path
                    d="M756.862 314.067H277.324C275.196 314.067 273.472 315.62 273.472 317.537C273.472 319.454 275.196 321.007 277.324 321.007H756.862C758.989 321.007 760.714 319.454 760.714 317.537C760.714 315.62 758.989 314.067 756.862 314.067Z"
                    fill="var(--sp-color-bg-side)"
                />
                <path
                    d="M423.689 279.363H277.324C275.196 279.363 273.472 280.917 273.472 282.833C273.472 284.75 275.196 286.304 277.324 286.304H423.689C425.816 286.304 427.54 284.75 427.54 282.833C427.54 280.917 425.816 279.363 423.689 279.363Z"
                    fill="var(--sp-color-bg-side)"
                />
                <path
                    d="M331.248 262.012H277.324C275.196 262.012 273.472 263.566 273.472 265.483C273.472 267.399 275.196 268.953 277.324 268.953H331.248C333.375 268.953 335.099 267.399 335.099 265.483C335.099 263.566 333.375 262.012 331.248 262.012Z"
                    fill="#FE551B"
                />
                <path
                    d="M992.779 91.9675H208.955V234.25H992.779V91.9675Z"
                    fill="var(--sp-color-bg-side)"
                />
                <g>
                    <path
                        d="M88.5894 393.824H65.4792C63.3519 393.824 61.6274 395.378 61.6274 397.294C61.6274 399.211 63.3519 400.765 65.4792 400.765H88.5894C90.7167 400.765 92.4412 399.211 92.4412 397.294C92.4412 395.378 90.7167 393.824 88.5894 393.824Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M117.477 376.472H65.4792C63.3519 376.472 61.6274 378.026 61.6274 379.943C61.6274 381.859 63.3519 383.413 65.4792 383.413H117.477C119.605 383.413 121.329 381.859 121.329 379.943C121.329 378.026 119.605 376.472 117.477 376.472Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M129.032 359.121H65.4792C63.3519 359.121 61.6274 360.675 61.6274 362.591C61.6274 364.508 63.3519 366.062 65.4792 366.062H129.032C131.16 366.062 132.884 364.508 132.884 362.591C132.884 360.675 131.16 359.121 129.032 359.121Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M105.922 341.77H65.4792C63.3519 341.77 61.6274 343.323 61.6274 345.24C61.6274 347.157 63.3519 348.71 65.4792 348.71H105.922C108.049 348.71 109.774 347.157 109.774 345.24C109.774 343.323 108.049 341.77 105.922 341.77Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M129.032 307.066H82.8118C80.6846 307.066 78.9601 308.62 78.9601 310.537C78.9601 312.453 80.6846 314.007 82.8118 314.007H129.032C131.16 314.007 132.884 312.453 132.884 310.537C132.884 308.62 131.16 307.066 129.032 307.066Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M115.551 289.715H82.8118C80.6846 289.715 78.9601 291.269 78.9601 293.185C78.9601 295.102 80.6846 296.655 82.8118 296.655H115.551C117.679 296.655 119.403 295.102 119.403 293.185C119.403 291.269 117.679 289.715 115.551 289.715Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M121.329 272.364H82.8118C80.6846 272.364 78.9601 273.917 78.9601 275.834C78.9601 277.75 80.6846 279.304 82.8118 279.304H121.329C123.456 279.304 125.181 277.75 125.181 275.834C125.181 273.917 123.456 272.364 121.329 272.364Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M125.181 255.012H82.8118C80.6846 255.012 78.9601 256.566 78.9601 258.483C78.9601 260.399 80.6846 261.953 82.8118 261.953H125.181C127.308 261.953 129.032 260.399 129.032 258.483C129.032 256.566 127.308 255.012 125.181 255.012Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M63.5533 255.012H61.6274V314.007H63.5533V255.012Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M105.922 237.661H65.4792C63.3519 237.661 61.6274 239.214 61.6274 241.131C61.6274 243.048 63.3519 244.601 65.4792 244.601H105.922C108.049 244.601 109.774 243.048 109.774 241.131C109.774 239.214 108.049 237.661 105.922 237.661Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M102.07 220.309H65.4792C63.3519 220.309 61.6274 221.863 61.6274 223.779C61.6274 225.696 63.3519 227.25 65.4792 227.25H102.07C104.198 227.25 105.922 225.696 105.922 223.779C105.922 221.863 104.198 220.309 102.07 220.309Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M109.774 202.958H65.4792C63.3519 202.958 61.6274 204.511 61.6274 206.428C61.6274 208.344 63.3519 209.898 65.4792 209.898H109.774C111.901 209.898 113.626 208.344 113.626 206.428C113.626 204.511 111.901 202.958 109.774 202.958Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M125.181 185.605H65.4792C63.3519 185.605 61.6274 187.159 61.6274 189.076C61.6274 190.992 63.3519 192.546 65.4792 192.546H125.181C127.308 192.546 129.032 190.992 129.032 189.076C129.032 187.159 127.308 185.605 125.181 185.605Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M119.403 168.255H65.4792C63.3519 168.255 61.6274 169.808 61.6274 171.725C61.6274 173.642 63.3519 175.195 65.4792 175.195H119.403C121.53 175.195 123.255 173.642 123.255 171.725C123.255 169.808 121.53 168.255 119.403 168.255Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M102.07 133.552H65.4792C63.3519 133.552 61.6274 135.105 61.6274 137.022C61.6274 138.938 63.3519 140.492 65.4792 140.492H102.07C104.198 140.492 105.922 138.938 105.922 137.022C105.922 135.105 104.198 133.552 102.07 133.552Z"
                        fill="var(--sp-color-bg-side)"
                    />
                    <path
                        d="M125.181 116.2H65.4792C63.3519 116.2 61.6274 117.754 61.6274 119.67C61.6274 121.587 63.3519 123.141 65.4792 123.141H125.181C127.308 123.141 129.032 121.587 129.032 119.67C129.032 117.754 127.308 116.2 125.181 116.2Z"
                        fill="var(--sp-color-bg-side)"
                    />
                </g>
                <path
                    d="M170.438 93.6431H51.0351C49.4397 93.6431 48.1464 94.8083 48.1464 96.2458V108.392C48.1464 109.829 49.4397 110.995 51.0351 110.995H170.438C172.034 110.995 173.327 109.829 173.327 108.392V96.2458C173.327 94.8083 172.034 93.6431 170.438 93.6431Z"
                    fill="#FE551B1f"
                />
                <path
                    d="M123.255 98.8486H65.4792C63.3519 98.8486 61.6274 100.402 61.6274 102.319C61.6274 104.236 63.3519 105.789 65.4792 105.789H123.255C125.382 105.789 127.107 104.236 127.107 102.319C127.107 100.402 125.382 98.8486 123.255 98.8486Z"
                    fill="#FE551B"
                />

                <path d="M1039 72.9768H0V73.8444H1039V72.9768Z" fill="var(--sp-color-bg-side)" />
                <path
                    d="M304.285 55.6252H263.842C261.715 55.6252 259.991 57.1789 259.991 59.0955C259.991 61.0121 261.715 62.5658 263.842 62.5658H304.285C306.413 62.5658 308.137 61.0121 308.137 59.0955C308.137 57.1789 306.413 55.6252 304.285 55.6252Z"
                    fill="var(--sp-color-bg-side)"
                />
                <path
                    d="M240.732 55.6252H207.993C205.865 55.6252 204.141 57.1789 204.141 59.0955C204.141 61.0121 205.865 62.5658 207.993 62.5658H240.732C242.859 62.5658 244.584 61.0121 244.584 59.0955C244.584 57.1789 242.859 55.6252 240.732 55.6252Z"
                    fill="var(--sp-color-bg-side)"
                />
                <path
                    d="M184.882 55.6252H134.81C132.683 55.6252 130.958 57.1789 130.958 59.0955C130.958 61.0121 132.683 62.5658 134.81 62.5658H184.882C187.01 62.5658 188.734 61.0121 188.734 59.0955C188.734 57.1789 187.01 55.6252 184.882 55.6252Z"
                    fill="var(--sp-color-bg-side)"
                />
                <path d="M115.551 72.1093H61.6274V73.8444H115.551V72.1093Z" fill="#FE551B" />
                <path
                    d="M111.7 55.6252H65.4792C63.3519 55.6252 61.6274 57.1789 61.6274 59.0955C61.6274 61.0121 63.3519 62.5658 65.4792 62.5658H111.7C113.827 62.5658 115.551 61.0121 115.551 59.0955C115.551 57.1789 113.827 55.6252 111.7 55.6252Z"
                    fill="#FE551B"
                />
                <path
                    d="M1039 0.0148926H0V44.2612H1039V0.0148926Z"
                    fill="var(--sp-color-bg-base)"
                />
                <g filter="url(#filter1_dd_33_6371)">
                    <rect
                        x="273"
                        y="9.01489"
                        width="303"
                        height="26.8358"
                        rx="13.4179"
                        fill="var(--sp-color-bg-side)"
                    />
                </g>
                <g clip-path="url(#clip1_33_6371)">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M289.195 16.9402C286.669 16.9402 284.62 18.9885 284.62 21.5152C284.62 24.0419 286.669 26.0902 289.195 26.0902C290.297 26.0902 291.307 25.7011 292.097 25.0528L294.502 27.4584C294.678 27.6341 294.963 27.6341 295.139 27.4584C295.314 27.2826 295.314 26.9977 295.139 26.822L292.733 24.4164C293.381 23.6269 293.77 22.6165 293.77 21.5152C293.77 18.9885 291.722 16.9402 289.195 16.9402ZM285.52 21.5152C285.52 19.4855 287.166 17.8402 289.195 17.8402C291.225 17.8402 292.87 19.4855 292.87 21.5152C292.87 23.5448 291.225 25.1902 289.195 25.1902C287.166 25.1902 285.52 23.5448 285.52 21.5152Z"
                        fill="#A6A09B"
                    />
                </g>
                <rect
                    x="305.945"
                    y="20.2651"
                    width="100"
                    height="4"
                    rx="2"
                    fill="var(--sp-color-bg-side)"
                />
                <g filter="url(#filter2_dd_33_6371)">
                    <rect
                        x="584.167"
                        y="9.27283"
                        width="53"
                        height="26.32"
                        rx="13.16"
                        fill="var(--sp-color-bg-side)"
                    />
                    <g clip-path="url(#clip2_33_6371)">
                        <path
                            d="M615.266 15.9115C615.293 15.833 615.404 15.833 615.432 15.9116C615.592 16.3676 615.691 16.6483 615.853 16.8897C615.996 17.1033 616.174 17.2912 616.38 17.4455C616.612 17.6199 616.887 17.7333 617.334 17.9176C617.413 17.9502 617.413 18.0622 617.334 18.0949C616.887 18.2791 616.612 18.3926 616.38 18.5669C616.174 18.7213 615.996 18.9092 615.853 19.1228C615.691 19.3641 615.592 19.6448 615.432 20.1009C615.404 20.1794 615.293 20.1794 615.266 20.1009C615.105 19.6448 615.007 19.3641 614.845 19.1228C614.702 18.9092 614.524 18.7213 614.318 18.5669C614.086 18.3926 613.811 18.2791 613.364 18.0949C613.285 18.0622 613.285 17.9502 613.364 17.9176C613.811 17.7333 614.086 17.6199 614.318 17.4455C614.524 17.2912 614.702 17.1033 614.845 16.8897C615.007 16.6483 615.105 16.3676 615.266 15.9115Z"
                            stroke="var(--sp-color-bg-tile-inverted-hovered)"
                            stroke-width="1.128"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M606.497 23.1709L609.975 25.1795C610.557 25.5153 611.274 25.5153 611.855 25.1795L616.543 22.4732C616.856 22.2923 617.248 22.5185 617.248 22.8803V24.574C617.248 24.7419 617.158 24.897 617.013 24.981L611.855 27.9586C611.274 28.2944 610.557 28.2944 609.975 27.9586L606.497 25.95C605.694 25.5328 604.088 24.249 604.088 22.4512M604.088 22.4512C604.088 21.159 604.885 20.5407 605.619 20.2869C606.113 20.1163 606.641 20.2763 607.093 20.5374L609.975 22.2016C610.557 22.5375 611.274 22.5375 611.855 22.2016L613.403 21.3083M604.088 22.4512C604.088 21.0177 605.065 19.9018 605.554 19.523L610.084 16.9073C610.47 16.6843 610.916 16.6094 611.342 16.6824"
                            stroke="var(--sp-color-bg-tile-inverted-hovered)"
                            stroke-width="1.128"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </g>
                </g>
                <g id="logo" transform="translate(-10 -41)">
                    <path
                        id="logomark"
                        d="M73.2533 54.1169C73.1947 54.0592 73.1654 54.0304 73.1279 54.0152C73.0904 54 73.0486 54 72.965 54H64.814C64.4026 54 64.1968 54 64.1448 54.12C64.0928 54.2401 64.2371 54.3819 64.5256 54.6657L72.323 62.3343C72.6115 62.6181 72.7558 62.7599 72.7038 62.88C72.6518 63 72.4461 63 72.0346 63H64.6796C64.2682 63 64.0625 63 64.0105 63.12C63.9585 63.2401 64.1027 63.3819 64.3912 63.6657L72.7467 71.8831C72.8053 71.9408 72.8346 71.9696 72.8721 71.9848C72.9096 72 72.9514 72 73.035 72H81.186C81.5974 72 81.8032 72 81.8552 71.88C81.9072 71.7599 81.7629 71.6181 81.4744 71.3343L73.677 63.6657C73.3885 63.3819 73.2442 63.2401 73.2962 63.12C73.3482 63 73.5539 63 73.9654 63H81.3204C81.7318 63 81.9375 63 81.9895 62.88C82.0415 62.7599 81.8973 62.6181 81.6088 62.3343L73.2533 54.1169Z"
                        fill="var(--sp-color-text-base)"
                    />
                    <g id="wordmark">
                        <g id="brand">
                            <text
                                id="title"
                                fill="var(--sp-color-text-base)"
                                xmlSpace="preserve"
                                style={{
                                    whiteSpace: 'pre',
                                }}
                                className="font-sans"
                                fontSize={14}
                                fontWeight={600}
                                letterSpacing="0em"
                            >
                                <tspan x={94} y={67.5909}>
                                    {name}
                                </tspan>
                            </text>
                        </g>
                    </g>
                </g>
                <defs>
                    <filter
                        id="filter1_dd_33_6371"
                        x="271"
                        y="7.01489"
                        width="307"
                        height="31.8358"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                    >
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="1" />
                        <feGaussianBlur stdDeviation="1" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_33_6371"
                        />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="-1" />
                        <feGaussianBlur stdDeviation="0.5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="effect1_dropShadow_33_6371"
                            result="effect2_dropShadow_33_6371"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect2_dropShadow_33_6371"
                            result="shape"
                        />
                    </filter>
                    <filter
                        id="filter2_dd_33_6371"
                        x="582.167"
                        y="7.27283"
                        width="57"
                        height="31.3199"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                    >
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="1" />
                        <feGaussianBlur stdDeviation="1" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_33_6371"
                        />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="-1" />
                        <feGaussianBlur stdDeviation="0.5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="effect1_dropShadow_33_6371"
                            result="effect2_dropShadow_33_6371"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect2_dropShadow_33_6371"
                            result="shape"
                        />
                    </filter>
                    <clipPath id="clip1_33_6371">
                        <rect
                            width="12"
                            height="12"
                            fill="var(--sp-color-bg-side)"
                            transform="translate(283.945 16.2651)"
                        />
                    </clipPath>
                    <clipPath id="clip2_33_6371">
                        <rect
                            width="15.04"
                            height="15.04"
                            fill="var(--sp-color-bg-side)"
                            transform="translate(603.147 14.9128)"
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
}
